<template>
  <div class="donor-wall mt-3 mt-md-0">
    <div class="donor-wall-heading gg-branding-lead-bg d-flex justify-content-center align-items-center">
      <h2 class="m-0 font-weight-bold">Donor Feed</h2>
    </div>
    <transition-group name="list" tag="ul">
      <li v-for="dtn in donations" :key="dtn.id" class="donation-list-item d-flex align-items-center">
        <img :src="dtn.group.logo" />
        <div class="donation-list-item-body w-75 pl-3 d-flex flex-column justify-content-center text-left">
          <h3 v-if="!dtn.hide_amount" class="dollar-amount gg-branding-supporting">
            {{ formattedDonation(dtn.intended_amount) }}
          </h3>
          <h4 class="donor-name font-weight-bold text-truncate">
            {{ dtn.public_name }}
          </h4>
          <i class="group-name d-block text-truncate">{{ dtn.group.name }}</i>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { centsToDollars } from '../utils.js'

export default {
  name: 'DonorWall',
  props: {
    donations: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    formattedDonation (amount) {
      return centsToDollars(amount);
    },
  }
}
</script>

<style scoped lang="scss">
.donor-wall {
  margin: 0 auto;
  border-radius: 10px 10px 0 0;
  background: linear-gradient(to bottom, #eaeaea, transparent);
}
.donor-wall-heading {
  border-radius: 10px 10px 0 0;
  padding: 1.5rem;

  @media screen and (min-width: 768px) {
    height: 9vh;
    padding: 2vh;
  }

  h2 {
    color: white;
    text-transform: uppercase;
    font-size: 2rem;

    @media screen and (min-width: 768px) {
      font-size: calc(2vh + 1vw);
    }
  }
}
ul {
  list-style-type: none;
  padding: 0;
}
.donation-list-item {
  margin: 1rem;

  img {
    max-width: 25%;
    max-height: 100%;
  }

  @media screen and (min-width: 768px) {
    height: 12vh;
    margin: 2vh;

    .donation-list-item-body {
      > * {
        line-height: 1;
        margin: 0;
      }

      .dollar-amount {
        font-size: 3.5vh;
        margin-bottom: 1vh;
      }
      .donor-name {
        font-size: 2.5vh;
        margin-bottom: .75vh;
      }
      .group-name {
        font-size: 2.5vh;
      }
    }
  }
}
.list-move {
  transition: transform .75s;
}
.list-enter-active, .list-leave-active {
  transition: all .75s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
